import React, { useState } from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function SubscriptionFAQ() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqItems = [
    {
      id: 'panel1',
      question: 'What are the benefits of a paid subscription?',
      answer: 'Paid subscriptions provide access to premium features including unlimited bookmarks, advanced search capabilities, priority support, and early access to new features.'
    },
    {
      id: 'panel2',
      question: 'How do I cancel my subscription?',
      answer: 'You can cancel your subscription at any time by clicking the "Cancel Subscription" button in your subscription details. Your subscription will remain active until the end of your current billing period.'
    },
    {
      id: 'panel3',
      question: 'Will I lose my data if I downgrade to the free plan?',
      answer: 'No, your data will be preserved if you downgrade. However, you may lose access to certain premium features and functionality until you resubscribe.'
    },
    {
      id: 'panel4',
      question: 'How secure is my payment information?',
      answer: 'We use Stripe for payment processing, which is PCI compliant and uses industry-standard encryption to keep your payment information secure. We never store your credit card details on our servers.'
    },
    {
      id: 'panel5',
      question: 'Can I change my subscription plan?',
      answer: 'Yes, you can change between monthly and annual plans. If you upgrade, the new plan takes effect immediately. If you downgrade, the change will take effect at the end of your current billing period , if you encountered any issues please contact us on support@thinkode.co.uk'
    }
  ];

  return (
    <Paper elevation={2} sx={{ p: 3, mt: 3 }}>
      <Typography variant="h5" gutterBottom>Frequently Asked Questions</Typography>
      <Box sx={{ mt: 2 }}>
        {faqItems.map((item) => (
          <Accordion 
            key={item.id} 
            expanded={expanded === item.id} 
            onChange={handleChange(item.id)}
            sx={{ mb: 1 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${item.id}-content`}
              id={`${item.id}-header`}
            >
              <Typography fontWeight="medium">{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Paper>
  );
}
